import * as React from "react";
const SvgPauseCircle20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M10.706 6.848v6.304h2.5V6.848h-2.5Zm-3.968 0h2.5v6.304h-2.5V6.848Z"
    }),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 7a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
      clipRule: "evenodd"
    })
  );
export default SvgPauseCircle20Px;
